import {Injectable} from '@angular/core';
import {AlertService} from './alert.service';

@Injectable()
export class ErrorHandlingService {

  constructor(private alertService: AlertService) {
  }

  public errorHandling(error) {
    if (error) {
      if (!error.ok && error.statusText) {
          if (error.statusText) {
              let xStatus = error.headers.get('X-Status') !== null ? ': ' + error.headers.get('X-Status') : "";
              let errorText = error.statusText + xStatus
              switch (error.status) {
                case 0:
                  // API not reachable?
                  this.alertService.error(error.statusText + ': Please check connection.');
                  break;
                case 500:
                  if (error.headers.get('X-Status') !== null) {
                    this.alertService.error(error.headers.get('X-Status'));
                  } else {
                    this.alertService.error(error.statusText);
                  }
                  break;
                case 400:
                case 409:
                  this.alertService.errorModal(errorText, '');
                  break;
                case 403:
                  this.alertService.errorModal(errorText, '');
                  break;
                case 404:
                  this.alertService.error(errorText);
                  break;
                default:
                  this.alertService.error(errorText);
                  break;
              }
          } else {
              this.alertService.error(error.status);
          }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/error-handling-service.ts